export default function CalendarClockIcon({ width = 24, height = 24, ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox='6.25 5.25 13.97 13.97'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}>
      <path
        d='M9.35521 9.67136C9.24044 9.67136 9.1474 9.57832 9.1474 9.46355C9.1474 9.34878 9.24044 9.25574 9.35521 9.25574'
        stroke='currentColor'
      />
      <path
        d='M9.35547 9.67136C9.47024 9.67136 9.56328 9.57832 9.56328 9.46355C9.56328 9.34878 9.47024 9.25574 9.35547 9.25574'
        stroke='currentColor'
      />
      <path
        d='M11.5719 9.67136C11.4571 9.67136 11.3641 9.57832 11.3641 9.46355C11.3641 9.34878 11.4571 9.25574 11.5719 9.25574'
        stroke='currentColor'
      />
      <path
        d='M11.5719 9.67136C11.6867 9.67136 11.7797 9.57832 11.7797 9.46355C11.7797 9.34878 11.6867 9.25574 11.5719 9.25574'
        stroke='currentColor'
      />
      <path
        d='M9.35521 11.6109C9.24044 11.6109 9.1474 11.5179 9.1474 11.4031C9.1474 11.2884 9.24044 11.1953 9.35521 11.1953'
        stroke='currentColor'
      />
      <path
        d='M9.35547 11.6109C9.47024 11.6109 9.56328 11.5179 9.56328 11.4031C9.56328 11.2884 9.47024 11.1953 9.35547 11.1953'
        stroke='currentColor'
      />
      <path
        d='M9.35521 13.5505C9.24044 13.5505 9.1474 13.4575 9.1474 13.3427C9.1474 13.2279 9.24044 13.1349 9.35521 13.1349'
        stroke='currentColor'
      />
      <path
        d='M9.35547 13.5505C9.47024 13.5505 9.56328 13.4575 9.56328 13.3427C9.56328 13.2279 9.47024 13.1349 9.35547 13.1349'
        stroke='currentColor'
      />
      <path
        d='M11.5719 11.6109C11.4571 11.6109 11.3641 11.5179 11.3641 11.4031C11.3641 11.2884 11.4571 11.1953 11.5719 11.1953'
        stroke='currentColor'
      />
      <path
        d='M11.5719 11.6109C11.6867 11.6109 11.7797 11.5179 11.7797 11.4031C11.7797 11.2884 11.6867 11.1953 11.5719 11.1953'
        stroke='currentColor'
      />
      <path
        d='M13.7886 9.67136C13.6738 9.67136 13.5807 9.57832 13.5807 9.46355C13.5807 9.34878 13.6738 9.25574 13.7886 9.25574'
        stroke='currentColor'
      />
      <path
        d='M13.7885 9.67136C13.9033 9.67136 13.9963 9.57832 13.9963 9.46355C13.9963 9.34878 13.9033 9.25574 13.7885 9.25574'
        stroke='currentColor'
      />
      <path
        d='M11.1562 15.1438H7.83125C7.61079 15.1438 7.39935 15.0562 7.24347 14.9004C7.08758 14.7445 7 14.533 7 14.3125V7.66255C7 7.44209 7.08758 7.23065 7.24347 7.07477C7.39935 6.91888 7.61079 6.8313 7.83125 6.8313H15.3125C15.5329 6.8313 15.7444 6.91888 15.9003 7.07477C16.0562 7.23065 16.1437 7.44209 16.1437 7.66255V10.1563'
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path d='M9.49377 7.6625V6' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M13.65 7.6625V6' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round' />
      <path
        d='M16.1437 18.4687C17.9801 18.4687 19.4687 16.9801 19.4687 15.1437C19.4687 13.3074 17.9801 11.8187 16.1437 11.8187C14.3074 11.8187 12.8187 13.3074 12.8187 15.1437C12.8187 16.9801 14.3074 18.4687 16.1437 18.4687Z'
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path d='M17.6123 15.1437H16.1437V13.6752' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  );
}
